import React from 'react';
import { Map } from 'immutable';
import c from 'classnames';
import { CoreLink } from '@uncinc/react-drupal-core';

const NavigationFooterMenuColumn = ({ item }) => {
  return (
    <div className="list-menu list-menu--secondary">
      <ul>
        {item.get('subtree').map((subItem) => {
          const attrs = subItem.getIn(['link', 'options', 'attributes'], new Map());
          const containerClasses = subItem.getIn(['link', 'options', 'container_attributes', 'class'], new Map());
          const href = subItem.getIn(['link', 'url'], '');
          const title = subItem.getIn(['link', 'title'], 'Untitled');

          let classNames = attrs.get('class', new Map());
          if (attrs.get('class') !== undefined) {
            classNames = classNames.toJS();
          }

          return (
            <li
              key={`menu--footer--menu-item-${title}:${href}`}
              className={c('NavigationFooterMenu__item', containerClasses)}
            >
              <div
                className="NavigationFooterMenu__title"
              >
                <CoreLink
                  to={href === '' ? '/' : href}
                  target={attrs.get('target')}
                  className={c(classNames)}
                >
                  {title}
                </CoreLink>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default NavigationFooterMenuColumn;
